import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemDepositePriceMaybe = props => {
  const { lineItems, code, intl, isProvider, isTransactionPage } = props;

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);
  const lineTotal = new Money(-(unitPurchase?.lineTotal?.amount), unitPurchase?.lineTotal?.currency);

  //   const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const total = unitPurchase ? formatMoney(intl, lineTotal) : null;

  //   return quantity && total ? (
  //     <div className={css.lineItem}>
  //       <span className={css.itemLabel}>
  //         <FormattedMessage id={'LineItemDepositePriceMaybe.depositeMoneyLabel'} />
  //       </span>
  //       <span className={css.itemValue}>{total}</span>
  //     </div>
  //   ) : null;

  return total && isProvider ? (
    <div className={css.lineItem}>
      {isTransactionPage ?
        <span className={css.itemLabel}>
          <FormattedMessage id={'LineItemDepositePriceMaybe.depositeMoneyPaidLabel'} />
        </span>
        :
        <span className={css.itemLabel}>
          <FormattedMessage id={'LineItemDepositePriceMaybe.depositeMoneyLabel'} />
        </span>
      }
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemDepositePriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemDepositePriceMaybe;